<template>
    <div v-if="vacationDuration" class="white rounded-lg pa-4">
        <div
            v-for="(calculatedDay, key) in vacationDuration.days"
            :key="key"
            class="d-flex"
        >
            <div class="body-2 font-weight-medium mr-1">
                {{ formatDate(key) }}
            </div>
            <div class="d-flex body-2">
                <template v-if="calculatedDay.removed_day_duration">
                    <span>{{ formatTimeDuration(calculatedDay.daily_duration) }}</span>
                    <span> - </span>
                    <span>{{ formatTimeDuration(calculatedDay.removed_day_duration) }}</span>
                    <span v-if="calculatedDay.events.length">
                        ({{ calculatedDay.events.map(x => x.name).join(', ') }})
                    </span>
                    <span> = </span>
                    <span>{{ formatTimeDuration(calculatedDay.expected_day_duration) }}</span>
                </template>
                <span v-else>
                    <span>{{ formatTimeDuration(calculatedDay.expected_day_duration) }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {$t} from "@/i18n";
import {
    formatTimeDuration,
    formatFlextimeDuration,
    formatDate,
} from "@/plugins/formatting";

export default {
    name: "VacationDurationList",
    props: {
        vacationDuration: {
            type: Object,
            default: null
        }
    },
    setup() {
        return {
            formatTimeDuration,
            formatFlextimeDuration,
            formatDate
        }
    }
}
</script>
